/*
  Crossfade carousel for the image pane of the split hero.
  Kept separate from <slide-section> on purpose: nesting a second Swiper inside
  a slide makes the outer instance claim the inner pagination element.
*/
class SplitHeroMedia extends HTMLElement {
  constructor() {
    super();
    this.slides = Array.from(this.querySelectorAll(".split-hero-media__item"));
    this.dots = Array.from(this.querySelectorAll(".split-hero-media__dot"));
    this.index = 0;
    this.timer = null;
  }

  connectedCallback() {
    if (this.slides.length < 2) return;
    this.autoplay = this.dataset.autoplay === "true";
    this.speed = (Number(this.dataset.autoplaySpeed) || 5) * 1000;

    this.dots.forEach((dot, i) => {
      dot.addEventListener("click", () => {
        this.goTo(i);
        this.restart();
      });
    });
    this.querySelector(".split-hero-media__prev")?.addEventListener("click", () => {
      this.goTo(this.index - 1);
      this.restart();
    });
    this.querySelector(".split-hero-media__next")?.addEventListener("click", () => {
      this.goTo(this.index + 1);
      this.restart();
    });

    this.addEventListener("mouseenter", () => this.stop());
    this.addEventListener("mouseleave", () => this.start());
    document.addEventListener("visibilitychange", () => {
      document.hidden ? this.stop() : this.start();
    });

    this.goTo(0);
    this.start();
  }

  disconnectedCallback() {
    this.stop();
  }

  goTo(i) {
    const total = this.slides.length;
    this.index = (i + total) % total;
    this.slides.forEach((slide, n) => {
      const active = n === this.index;
      slide.classList.toggle("is-active", active);
      slide.setAttribute("aria-hidden", active ? "false" : "true");
    });
    this.dots.forEach((dot, n) => {
      const active = n === this.index;
      dot.classList.toggle("is-active", active);
      dot.setAttribute("aria-current", active ? "true" : "false");
    });
  }

  start() {
    if (!this.autoplay || this.timer || this.slides.length < 2) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    this.timer = setInterval(() => this.goTo(this.index + 1), this.speed);
  }

  stop() {
    clearInterval(this.timer);
    this.timer = null;
  }

  restart() {
    this.stop();
    this.start();
  }
}
customElements.define("split-hero-media", SplitHeroMedia);
